import React, { Component } from "react";
import { DynamicFormFieldProps } from "../DynamicForm";
import { DynamicFormField } from "../../laco-common/base/form-validation/dynamic";
import { ISelectFormField } from "../../laco-common";
import { ISiteContentBlock, getSiteWidgetTypes } from "../../models/cms";
import { WithOptional } from "../../laco-common/helpers/extendedTypes";
import ItemFormInput from "./ItemForm";
import { WidgetType } from "../../laco-common/base/models/widget";
import { MediaAccepted, UploadFormat, UploadMode } from "../../laco-common/base/models/upload";

const getFields = (
	data: ISiteContentBlock
): Record<keyof ISiteContentBlock, DynamicFormField & WithOptional<Partial<ISelectFormField>, "id" | "fieldType">> => {
	// const fieldsMap: Record<keyof ISiteContentBlock, DynamicFormField> = {
	return {
		title: { order: 0, value: data?.title, label: "Title", optional: true },
		isMainHeading: {
			order: 10,
			value: data?.isMainHeading,
			label: "Main Heading",
			fieldType: "boolean",
			optional: true,
		},
		content: { order: 20, value: data?.content, label: "Content", fieldType: "html", optional: true },
		iconUrl: { order: 500, value: data?.iconUrl, label: "Icon", fieldType: "imageUrl", optional: true },
		media: {
			order: 40,
			value: null,
			label: "Media",
			optional: true,
			fieldType: "media",
			mediaOptions: {
				path: "site/media",
			},
		},
		displayImageWLayersBg: {
			order: 41,
			value: null,
			label: "Display Image On Background Layers",
			optional: true,
			fieldType: "boolean",
		},
		renderSimpleMedia: {
			order: 42,
			value: null,
			label: "Render Simple Image",
			optional: true,
			fieldType: "boolean",
		},
		textFirst: {
			order: 43,
			value: data?.textFirst,
			label: "Text First",
			fieldType: "boolean",
			optional: true,
		},
		linkText: { order: 60, value: data?.linkText, label: "Link Text", optional: true },
		linkUrl: { order: 70, value: data?.linkUrl, label: "Link Url", fieldType: "link", optional: true },
		isInternalLink: {
			order: 80,
			value: data?.isInternalLink,
			label: "Internal Link",
			fieldType: "boolean",
			optional: true,
		},
		buttonLinkType: {
			order: 86,
			value: data?.buttonLinkType,
			label: "Button Link Type",
			fieldType: "select",
			selectOptions: [
				{ label: "Outlined Gray", value: "default" },
				{ label: "Outlined Orange", value: "link" },
				{ label: "Primary (Orange)", value: "primary" },
				{ label: "Blue", value: "info" },
				{ label: "Gray", value: "secondary" },
				{ label: "Warning (Light Orange)", value: "warning" },
				{ label: "Error (Red)", value: "danger" },
				{ label: "Success (Green)", value: "success" },
			],
			optional: true,
		},
		xlButton: {
			order: 87,
			value: data?.xlButton,
			label: "XL Button",
			fieldType: "boolean",
			optional: true,
		},
		buttonMarginLeft: {
			order: 88,
			value: data?.buttonMarginLeft,
			label: "Button Margin Left",
			fieldType: "select",
			selectValues: [1, 2, 3, 4, 5],
			optional: true,
		},
		fullWidth: { order: 90, value: data?.fullWidth, label: "Full Width", fieldType: "boolean", optional: true },
		textGrow: { order: 100, value: data?.textGrow, label: "Text Grow", fieldType: "boolean", optional: true },
		imageGrow: { order: 101, value: data?.imageGrow, label: "Image Grow", fieldType: "boolean", optional: true },
		preserveOrderOnMobile: {
			order: 102,
			value: data?.preserveOrderOnMobile,
			label: "Preserve Order on Mobile",
			fieldType: "boolean",
			optional: true,
		},
		alignTop: { order: 110, value: data?.alignTop, label: "Align Top", fieldType: "boolean", optional: true },
		widgets: {
			order: 120,
			value: data?.widgets,
			label: "Widgets",
			fieldType: "chips",
			selectValues: getSiteWidgetTypes().map((w: WidgetType) => {
				return { label: w, value: w };
			}),
			optional: true,
		},
	};
};

export default class TextBlockInput extends Component<DynamicFormFieldProps> {
	render() {
		return (
			<ItemFormInput
				{...this.props}
				itemName="Content Section"
				nameField="title"
				viewItemSelector=".ui-text-block"
				getFields={getFields}
				createNew={() => {
					return { title: "Sample title", isMainHeading: true, content: "Sample content" };
				}}
			/>
		);
	}
}
